import { render, staticRenderFns } from "./breed_mode_page.vue?vue&type=template&id=7bb326e5&scoped=true"
import script from "./breed_mode_page.vue?vue&type=script&lang=js"
export * from "./breed_mode_page.vue?vue&type=script&lang=js"
import style0 from "./breed_mode_page.vue?vue&type=style&index=0&id=7bb326e5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb326e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bb326e5')) {
      api.createRecord('7bb326e5', component.options)
    } else {
      api.reload('7bb326e5', component.options)
    }
    module.hot.accept("./breed_mode_page.vue?vue&type=template&id=7bb326e5&scoped=true", function () {
      api.rerender('7bb326e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/breed_mode_page.vue"
export default component.exports